import moment from 'moment-timezone';
import React, { Component } from 'react';
import { Accordion, FloatingLabel, Form, InputGroup } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Dropdown from 'react-bootstrap/Dropdown';
import './friends-menu.css';
import Row from 'react-bootstrap/Row';
import { MemberProfile } from '../PlayerManagement/Profile';
import { DiscordContext } from '../../discord/DiscordContext';
import { getLocalDisplayName } from '../../hooks/useLocalDisplayName';

const VARIANTS = [
    null, 'deep', 'stem', 'hex', 'dread', 'honored', 'seed'
];

// Find-by-name search tuning. 250ms debounce keeps us off the socket
// on every keystroke; a 2-char floor stops "a"-shaped fishing queries
// (mirrored by the backend's FRIEND_SEARCH_LIMIT / min-length gate).
const FIND_DEBOUNCE_MS = 250;
const FIND_MIN_QUERY_LENGTH = 2;

// Mirrors lobbies.models.LobbyStatus.FORMING_ID — the same JS-side
// mirror GamePage.js / DiscordProvider.js / Lobby.js keep (we do NOT
// import status ids from the backend).
const LOBBY_STATUS_FORMING_ID = 1;


// True when the local user OWNS a lobby that is still FORMING — the
// precondition for inviting friends into it (CC_FRIENDS_INVITE_FROM_LOBBY).
// Reads the live groupHandler so a Friends menu that mounts AFTER the
// forming lobby's Members broadcast (e.g. the owner navigated back to the
// Main Menu while the lobby still forms) gates correctly; the
// group-update-event listener keeps it fresh thereafter.
function ownsFormingLobbyFromHandler(app) {
    const handler = app && app.game && app.game.groupHandler;
    if (!handler || typeof handler.isGroupLeader !== 'function') {
        return false;
    }
    if (!handler.isGroupLeader()) {
        return false;
    }
    const config = handler.lobbyConfig;
    return !!(config && config.status_id === LOBBY_STATUS_FORMING_ID);
}


// Same gate, derived from a group-update-event detail (which carries
// isGroupLeader + lobbyConfig) rather than the handler snapshot.
function ownsFormingLobbyFromDetail(detail) {
    const config = (detail && detail.lobbyConfig) || null;
    return !!(detail && detail.isGroupLeader
        && config && config.status_id === LOBBY_STATUS_FORMING_ID);
}


export class AddFriend extends Component {

    constructor(props) {
        super(props);
        this.state = {
            errors: {},
            toggle: false,
            emailToggle: false,
            query: '',

            isValid: false,
            isSaved: false,
            email: '',
            emailIsValid: false,
            emailValidationmessage: '',

        };
        this.debounceTimer = null;
    }

    componentWillUnmount() {
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = null;
        }
    }

    toggle = () => {
        this.setState({ toggle: true });
        this.props.setKeepMenuOpen();
    };

    toggleEmail = () => {
        this.setState((prev) => ({ emailToggle: !prev.emailToggle }));
        this.props.setKeepMenuOpen();
    };

    sendFind = (query) => {
        let typeName = 'Friend';
        let packageValue = {
            type: 'Find', data: { type: 'find', q: query }
        };
        this.props.app.state.authenticator.sendMessage(
            typeName, packageValue);
    };

    onQueryChange = (event) => {
        const value = event.target.value;
        this.setState({ query: value });
        this.props.setKeepMenuOpen();
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = null;
        }
        // value.length < FIND_MIN_QUERY_LENGTH clears the result list
        // locally (the render gate below) without hitting the socket.
        if (value.length >= FIND_MIN_QUERY_LENGTH) {
            this.debounceTimer = setTimeout(() => {
                this.sendFind(value);
                this.debounceTimer = null;
            }, FIND_DEBOUNCE_MS);
        }
    };

    inviteCandidate = (result) => {
        let typeName = 'Friend';
        let packageValue = {
            type: 'Invite', data: { type: 'invite', user: result.id }
        };
        this.props.app.state.authenticator.sendMessage(
            typeName, packageValue);
        // Collapse back to the clean "Add Friend" button so the next
        // open isn't dumped into a sprung-open search panel.
        this.setState({ query: '', toggle: false }, this.props.shutMenu);
    };

    addFriend = (event) => {
        event.preventDefault();
        const isValid = this.state.emailIsValid;
        if (isValid) {
            let typeName = 'Friend';
            let packageValue = {
                type: 'Invite', data: {
                    type: 'invite', email: this.state.email
                }
            };
            this.props.app.state.authenticator.sendMessage(
                typeName, packageValue);
        }
        this.setState(
            { emailToggle: false, toggle: false, email: '' },
            this.props.shutMenu);
    };

    onFieldChange = (event) => {
        const isValid = event.target.validity.valid;
        const validationMessage = event.target.validationMessage;
        const fieldName = event.target.name;
        let newStates = { isSaved: false };
        newStates.isValid = !validationMessage;
        newStates[fieldName] = event.target.value;
        const isValidName = fieldName + 'IsValid';
        newStates[isValidName] = isValid;
        const validationMessageName = fieldName + 'ValidationMessage';
        newStates[validationMessageName] = validationMessage;
        this.setState(newStates);
    };


    render() {
        // A Discord-linked viewer has a synthetic email of their own and
        // no UI to change it — an email-invite path is a dead end for
        // them, so the secondary toggle is suppressed entirely.
        let user = this.props.app.state.authenticator.account.user;
        let isDiscordLinked = !!(user && user.is_discord_linked);
        // Result list is gated on the live query length so a sub-2-char
        // query shows nothing even if a stale push is still in props.
        let results = (this.state.query.length >= FIND_MIN_QUERY_LENGTH
            && this.props.findResults) || [];
        return (<>
                {(!this.state.toggle) &&
                    <Button onClick={this.toggle}
                            variant={'honored'}
                            style={{width: '100%'}}>Add Friend</Button>
                }
                {this.state.toggle &&
                <div style={{ width: '340px', alignItems: 'center' }}>
                    <Form.Control
                        type="text"
                        placeholder={'Find by player name or Discord handle'}
                        onChange={this.onQueryChange}
                        onFocus={this.props.setKeepMenuOpen}
                        value={this.state.query}
                        aria-label="Find friends"
                    />
                    {results.map((result) => {
                        return <div
                            key={result.id}
                            className={'friends-list-dropdown-menu-item'}
                            onClick={() => { this.inviteCandidate(result); }}
                        >
                            {result.display_name}
                            {result.status && result.status.connected &&
                                <span className={'friend-online'}>●</span>}
                        </div>;
                    })}

                    {!isDiscordLinked && <>
                        <Button onClick={this.toggleEmail}
                                variant={'link'}
                                style={{ width: '100%' }}>
                            Invite by email
                        </Button>
                        {this.state.emailToggle &&
                            <Form style={{ color: 'black', width: '100%' }}
                                  validated={!this.state.isSaved}>
                                <InputGroup hasValidation>
                                    <Form.Control
                                        id={'email'}
                                        name={'email'}
                                        type="email"
                                        placeholder={'Your Friend\'s eMail'}
                                        onChange={this.onFieldChange}
                                        value={this.state.email}
                                        isInvalid={!!this.state.errors.email}
                                        aria-label="Friend email"
                                        aria-describedby="basic-addon2"
                                        required
                                    />

                                    <Button variant="outline-secondary" id="button-addon2"
                                            type={'submit'}
                                            onClick={this.addFriend}
                                    >
                                        Send
                                    </Button>
                                    <Form.Control.Feedback type="invalid">
                                        {this.state.errors.email}
                                    </Form.Control.Feedback>
                                </InputGroup>
                            </Form>
                        }
                    </>}
                </div>
                }
            </>
        );
    }
}


export class OnlineFriendCounter extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }


    render() {
        let userId = this.props.app.state.authenticator.account.user.id;
        let onlineFriends = this.props.listData.friends.filter((friend) => {
            if (friend.user.id === userId) {
                return friend.friend.status.connected;
            } else {
                return friend.user.status.connected;
            }
        }).length;
        return (<div className={'online-friend-counter-anchor'}>
                <div className={'online-friend-counter'}>
                    {onlineFriends}
                </div>
            </div>
        );
    }
}

export class OnlineFriendMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };
        this.profileModal = null;
    }

    onMouseLeave = (isOpen, e) => {
        this.setState({ isOpen: false });
    };

    onMouseEnter = (isOpen, e) => {
        this.setState({ isOpen: true });
    };

    onToggleHandler = (isOpen, e) => {
        this.setState({ isOpen: isOpen });
    };

    kick = () => {
        let typeName = 'Group';
        let packageValue = {
            type: 'Kick',
            data: {
                type: 'kick',
                user: this.props.displayMember.user.id
            }
        };
        this.props.app.state.authenticator.sendMessage(typeName, packageValue);
    }

    addFriend = () => {
        let typeName = 'Friend';
        let packageValue = {
            type: 'Invite', data: {
                type: 'invite', email: this.state.email
            }
        };
        this.props.app.state.authenticator.sendMessage(typeName, packageValue);
    }

    showProfile = () => {
        this.profileModal.show();
    }

    invite = (user) => {
        let typeName = 'Group';
        let packageValue = { type: 'Invite', data: { user: user.id } };
        this.props.app.state.authenticator.sendMessage(typeName, packageValue);
    };

    render() {
        console.log('friend render')
        let friendRecord = this.props.friend;
        let userId = this.props.app.state.authenticator.account.user.id;
        let friend = friendRecord.user.id === userId ? friendRecord.friend : friendRecord.user
        let member = friend;
        member.user = friend;
        return <>
            <MemberProfile {...this.props}
                           member={member}
                           ref={(ref) => this.profileModal=ref }
            />
            <div id={'friend-wrapper'} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                <div className={'friends-list-accordion-item-header-text'}>
                {friend.display_name} - {friend.rank}
                </div>
                {this.state.isOpen && <div style={{textAlign: 'right', color: 'white'}}>
                    {/* CC_FRIENDS_INVITE_FROM_LOBBY: the Invite affordance
                        rides the existing Group/Invite rail (invite() →
                        sendMessage('Group', {type:'Invite', ...})) but is
                        gated on owning a FORMING lobby — there is nothing to
                        invite a friend into otherwise, and the backend
                        invite handler no-ops without a held lobby. */}
                    {this.props.ownsFormingLobby &&
                        <div onClick={() => {this.invite(friend)}}>Invite</div>}
                    <div onClick={this.showProfile}>Profile</div>
                </div>}
            </div>
        </>;
    }
}


export class FriendsList extends Component {
    // Discord context so getLocalDisplayName resolves the local user's
    // real name (nick → global_name → @handle) rather than the
    // discord_<snowflake> username.
    static contextType = DiscordContext;

    constructor(props) {
        super(props);
        this.state = { activeKey: 0, };
    }

    acceptFriendRequest = (request) => {
        let typeName = 'Friend';
        let packageValue = {
            type: 'Accept',
            data: { friend_request: request.id }
        };
        this.props.app.state.authenticator.sendMessage(typeName, packageValue);
    };

    render() {
        let props = { ...this.props, ...this.state };
        let userId = props.app.state.authenticator.account.user.id;
        let offlineFriends = this.props.listData.friends.filter((friend) => {
            if (friend.user.id === userId) {
                return !friend.friend.status.connected;
            } else {
                return !friend.user.status.connected;
            }});
        let onlineFriends = this.props.listData.friends.filter((friend) => {
            if (friend.user.id === userId) {
                return friend.friend.status.connected;
            } else {
                return friend.user.status.connected;
            }});

        return (<div className={'friends-list'}>
                <Accordion defaultActiveKey={'1'} style={{ background: 'transparent' }}>
                    {props.listData.pending.length > 0 &&
                        <Accordion.Item
                            eventKey="0"
                            className={'friends-list-accordion-item'}

                        >
                            <Accordion.Header className={'friends-list-accordion-item-header'}>
                                Pending ({props.listData.pending.length})
                            </Accordion.Header>
                            <Accordion.Body style={{ background: 'transparent' }}>
                                {props.listData.pending.map((request, friendIndex) => {
                                    return <Dropdown.Item
                                        key={friendIndex}
                                        className={'friends-list-dropdown-menu-item'}
                                        onClick={() => {
                                            this.acceptFriendRequest(request);
                                        }}
                                    >
                                        {request.user.display_name}
                                    </Dropdown.Item>;
                                })}
                            </Accordion.Body>
                        </Accordion.Item>
                    }
                    <Accordion.Item
                        eventKey="1"
                        className={'friends-list-accordion-item'}
                    >
                        <Accordion.Header className={'friends-list-accordion-item-header'}>
                            <div className={'friends-list-accordion-item-header-text'}>
                                Online Friends ({onlineFriends.length})
                            </div>
                        </Accordion.Header>
                        <Accordion.Body style={{ background: 'transparent' }}>
                            {onlineFriends.map((friend, friendIndex) => {
                                return <Dropdown.Item
                                    key={friendIndex}
                                    className={'friends-list-dropdown-menu-item friend-online'}
                                    onClick={() => {
                                    console.log('ONLINE FRIEND', friend);
                                }}
                                >
                                    <OnlineFriendMenu key={friendIndex}
                                                       {...this.props}
                                                       friend={friend} />
                                </Dropdown.Item>;
                            })}
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item
                        eventKey="2"
                        className={'friends-list-accordion-item'}
                    >
                        <Accordion.Header className={'friends-list-accordion-item-header'}>
                            <div className={'friends-list-accordion-item-header-text'}>
                                Offline Friends ({offlineFriends.length})
                            </div>
                        </Accordion.Header>
                        <Accordion.Body style={{ background: 'transparent' }}>
                            {offlineFriends.map((friend, friendIndex) => {
                                return <Dropdown.Item
                                    key={friendIndex}
                                    className={'friend-offline friends-list-dropdown-menu-item'}
                                    onClick={() => {
                                        console.log('OFFLINE FRIEND', friend)
                                    }}
                                >
                                    {friend.user.id === userId ? friend.friend.display_name : friend.user.display_name}
                                </Dropdown.Item>;
                            })}
                        </Accordion.Body>
                    </Accordion.Item>

                    {props.listData.requests.length > 0 && <>
                        <Accordion.Item
                            eventKey="3"
                            className={'friends-list-accordion-item'}
                        >
                            <Accordion.Header className={'friends-list-accordion-item-header'}>
                                <div className={'friends-list-accordion-item-header-text'}>
                                    Requests ({props.listData.requests.length})
                                </div>
                            </Accordion.Header>
                            <Accordion.Body style={{ background: 'transparent' }}>
                                {props.listData.requests.map((request, friendIndex) => {
                                    return <Dropdown.Item
                                        key={friendIndex}
                                        className={'friends-list-dropdown-menu-item'}>
                                        {(request.friend && request.friend.display_name) || request.email} {moment(request.created).fromNow()}
                                    </Dropdown.Item>;
                                })}
                            </Accordion.Body>
                        </Accordion.Item>
                    </>}
                </Accordion>
            </div>
        )
    }
}


export default class FriendsMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            forceOpen: false,
            listData: {
                friends: [],
                requests: [],
                pending: [],
            },
            findResults: [],
            // CC_FRIENDS_INVITE_FROM_LOBBY: seed from the live groupHandler
            // so the friend-row Invite gate is correct even on a fresh
            // mount that follows the forming lobby's Members broadcast.
            ownsFormingLobby: ownsFormingLobbyFromHandler(props.app),
        };
        props.app.friendsMenu = this;
        this.keepMenuOpen = false;
        this.fetchTimer = null;
    }

    componentDidMount() {
        this.fetchTimer = setTimeout(this.fetchFriends, 2000);
        window.addEventListener('group-update-event', this.onGroupUpdate);
        window.addEventListener('leave-group-event', this.onLeftGroup);
        window.addEventListener('lobby-destroyed-event', this.onLeftGroup);
    }

    componentWillUnmount() {
        if (this.fetchTimer) {
            clearTimeout(this.fetchTimer);
            this.fetchTimer = null;
        }
        window.removeEventListener('group-update-event', this.onGroupUpdate);
        window.removeEventListener('leave-group-event', this.onLeftGroup);
        window.removeEventListener('lobby-destroyed-event', this.onLeftGroup);
    }

    onGroupUpdate = (e) => {
        this.setState({
            ownsFormingLobby: ownsFormingLobbyFromDetail(e && e.detail),
        });
    };

    onLeftGroup = () => {
        this.setState({ ownsFormingLobby: false });
    };

    fetchFriends = () => {
        let typeName = 'Friend';
        let packageValue = { type: 'Friends', data: { type: 'friends' } };
        this.props.app.state.authenticator.sendMessage(typeName, packageValue);
        this.fetchTimer = null;
    };

    receiveFriends = (receivedMessage) => {
        this.setState({ listData: receivedMessage.package.data });
    };

    receiveFindResults = (receivedMessage) => {
        this.setState({ findResults: receivedMessage.package.data.results });
    };

    onToggleHandler = (isOpen, e) => {
        if (e.source === 'rootClose') {
            this.keepMenuOpen = false;
        }
        if (this.keepMenuOpen) {
            this.setState({ isOpen: true });
        } else {
            this.setState({ isOpen: isOpen });
        }
    };

    setKeepMenuOpen = () => {
        this.keepMenuOpen = true;
        this.setState({ isOpen: true, forceOpen: true });
    };

    shutMenu = () => {
        this.keepMenuOpen = false;
        this.setState({ isOpen: false, forceOpen: false });
    };

    render() {
        let gamePlayerData = this.props.gamePlayerData;
        let variant = 'deep';
        if (gamePlayerData) {
            variant = VARIANTS[gamePlayerData.faction];
        }

        let displayName = getLocalDisplayName(this.props.app, this.context);
        let props = { ...this.props, ...this.state };

        return (<>
                <div id={'friends-menu-container'}
                     className={'friends-menu-container'}>
                <OnlineFriendCounter {...props} />
                <div id={'friends-menu'}
                     className={'friends-menu'}
                >
                    <div id={'button-wrapper'}>
                        <Dropdown
                            // autoClose="outside"
                            show={this.state.isOpen}
                            onToggle={this.onToggleHandler}
                        >
                            <Dropdown.Toggle
                                variant={variant}
                                id="dropdown-basic"
                                className={'friends-menu-button'}
                            >
                                &#x1F465;
                            </Dropdown.Toggle>
                            <Dropdown.Menu className={'friends-list-menu-container'}>
                                <Dropdown.Item className={'friends-list-dropdown-menu-item'}><h3 style={{color: 'white'}}>{displayName}</h3></Dropdown.Item>
                                {/* CC_RETIRE_LFG_TOGGLE (2026-06-07): the
                                    Looking-For-Group checkbox used to sit here.
                                    The LFG advertise flag is retired — discovery
                                    is public lobbies + friend invites. */}
                                <Dropdown.Divider/>
                                <FriendsList {...props} setKeepMenuOpen={this.setKeepMenuOpen} shutMenu={this.shutMenu}/>
                                <Dropdown.Divider/>
                                <Dropdown.Item className={'friends-list-dropdown-menu-item'}>
                                    <AddFriend {...this.props} findResults={this.state.findResults} setKeepMenuOpen={this.setKeepMenuOpen} shutMenu={this.shutMenu}/>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown></div>
                </div>
                </div>
            </>
        );
    }
}
